import { createFileRoute } from "@tanstack/react-router";
import { Skills } from "@/components/Skills";

function RouteComponent() {
  return <Skills />;
}

export const Route = createFileRoute("/_authenticated/skills/")({
  component: RouteComponent,
  staticData: { page: "engineering" },
});
